import { selectStyle } from "Redux/appSlice";
import { useAppSelector } from "Redux/hooks";
import { useEffect, useRef } from "react";
import { useState } from "react";

type Props = {
  elements: {
    label: string;
    id: string;
    current: boolean;
  }[];
  className?: string;
  onClick: (id: string) => void;
  onClose?: () => void;
};

// @function GuideButtons
// Guide Button renders button next to each other
// @param {{label: string, id: string, current: boolean}[]} elements
// @param {string} className
// @param {function} onClick
// @returns {React.Node}
export default function GuideButtons({
  elements = [],
  className = "",
  onClick,
  onClose,
}: Props) {
  const { color2 } = useAppSelector(selectStyle);
  const [isOn, setIsOn] = useState(() => {
    const currentElement = elements.find((el) => el.current);
    return currentElement?.id;
  });

  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    setIsOn(() => {
      const currentElement = elements.find((el) => el.current);
      return currentElement?.id || elements[0].id;
    });
  }, [elements]);

  const colouring = {
    color: {
      current: color2,
      other: "#A6A6A6",
    },
  };

  // TODO: use className directly in button element and use colors with tailwind
  const button_element = {
    className: `w-fit px-4 pb-2  border-b-2 font-bold border-solid ${className}`,
    styles: {
      on: {
        color: colouring.color.current,
        borderColor: colouring.color.current,
      },
      off: {
        color: colouring.color.other,
        borderColor: "#D9D9D9",
      },
    },
  };
  return (
    <div className={className + " flex flex-row"}>
      {elements.map(function (element) {
        return (
          <div key={element.id} className="flex flex-row">
            <button
              onMouseOver={() => {
                if (buttonRef.current && isOn !== element.id) {
                  buttonRef.current.style.borderColor = "#A6A6A6";
                }
              }}
              onMouseOut={() => {
                if (buttonRef.current && isOn !== element.id) {
                  buttonRef.current.style.borderColor = "#D9D9D9";
                }
              }}
              ref={buttonRef}
              className={button_element.className}
              style={
                isOn === element.id
                  ? button_element.styles.on
                  : button_element.styles.off
              }
              key={element.id}
              id={element.id}
              onClick={() => {
                setIsOn(element.id);
                onClick(element.id);
              }}
            >
              {element.label}
            </button>
            {onClose !== undefined && (
              <div className="cursor-pointer" onClick={onClose}>
                x
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
